// Guide Chapter front-end script (no-op)
// Server-side render handles Prev/Next logic and anchors (#chapterN).
// Keep this file to satisfy block.json's "viewScript" without mutating the DOM.

document.addEventListener('DOMContentLoaded', () => {
  // Intentionally empty.
});
